import { CoreLeagueLadderView } from '../../../../views';
import LadderTeamRow from '../LadderTeamRow';
import './index.styl';

/**
 * @desc League CoreLeagueLadderView View Class
 * This class using on league loin page ('fantasy/league/ladder')
 */
export class LadderTable extends CoreLeagueLadderView {
	get className() {
		return "table-row-item ladder-row";
	}

	get childView() {
		return LadderTeamRow;
	}
}

export default LadderTable;